import React from 'react';
import { useSelector } from 'react-redux';
import getProductPageSelectors from 'store/product/selector/getProductPageSelectors';
import getProductAttributeValue from 'utils/attributes/getProductAttributeValue';
import getProductItem from 'store/product/selector/getProductItem';
import styles from './CurrentProductAttributes.module.scss';

const ProductAttributes = () => {
  const productItem = useSelector(getProductItem);
  const productPageSelectors = useSelector(getProductPageSelectors);
  const attributesToDisplay = productPageSelectors
    .filter((selector) => !selector.isHidden)
    .map((selector) => selector.typeName);

  if (attributesToDisplay.length === 0 || !productItem) {
    return null;
  }

  return (
    <div className={styles.productAttributes}>
      {attributesToDisplay.map((attributeTyoeName) => (
        <span>{getProductAttributeValue(productItem.product, attributeTyoeName)}</span>
      ))}
    </div>
  );
};

export default ProductAttributes;
